 //import './_language.js';

window.addEventListener("load", function () {
    const btnBurger = document.querySelector('#totalfootball-ld-25-submit-navigation .btn-burger');
    const dropdownMenu = document.querySelector('#totalfootball-ld-25-submit-navigation .dropdown-menu');
    const languageInput = document.querySelector('#totalfootball-ld-25-submit-navigation #language');
    const languageContainer = document.querySelector('#totalfootball-ld-25-submit-navigation .language');
    
    if (btnBurger && dropdownMenu) {
        btnBurger.addEventListener('click', function() {
            dropdownMenu.classList.toggle('active');
        });
    }

    // Đóng language dropdown khi click ra ngoài trên PC
    if (languageInput && languageContainer) {
        document.addEventListener('click', function(event) {
            // Kiểm tra xem có phải PC không (btn-burger chỉ hiển thị trên mobile)
            const isPC = window.innerWidth > 768 || !btnBurger.offsetParent;
            
            // Kiểm tra click có nằm ngoài language container không
            const isClickOutside = !languageContainer.contains(event.target);
            
            if (isPC && isClickOutside && languageInput.checked) {
                languageInput.checked = false;
            }
        });
    }

    // Xử lý click menu để chuyển slide
    function initMenuClick() {
        // Đợi swiper sẵn sàng
        if (!window.swiper || typeof window.swiper.slideTo !== 'function') {
            setTimeout(initMenuClick, 100);
            return;
        }

        // Lấy các menu items
        const menuHome = document.querySelector('#totalfootball-ld-25-submit-navigation .list-items-home');
        const menuUpdate = document.querySelector('#totalfootball-ld-25-submit-navigation .list-items-update');
        const menuDaily = document.querySelector('#totalfootball-ld-25-submit-navigation .list-items-daily');
        const menuLucky = document.querySelector('#totalfootball-ld-25-submit-navigation .list-items-lucky');

        // Hàm để ẩn dropdown menu trên mobile
        function hideDropdownOnMobile() {
            // Kiểm tra nếu là mobile (btn-burger hiển thị)
            if (btnBurger && btnBurger.offsetParent !== null) {
                dropdownMenu.classList.remove('active');
            }
        }

        // Thêm event listeners cho 4 menu items
        if (menuHome) {
            menuHome.addEventListener('click', function(e) {
                e.preventDefault();
                if (window.swiper) {
                    window.swiper.slideTo(0, 800);
                }
                hideDropdownOnMobile();
            });
        }

        if (menuUpdate) {
            menuUpdate.addEventListener('click', function(e) {
                e.preventDefault();
                if (window.swiper) {
                    window.swiper.slideTo(1, 800);
                }
                hideDropdownOnMobile();
            });
        }

        if (menuDaily) {
            menuDaily.addEventListener('click', function(e) {
                e.preventDefault();
                if (window.swiper) {
                    window.swiper.slideTo(2, 800);
                }
                hideDropdownOnMobile();
            });
        }

        if (menuLucky) {
            menuLucky.addEventListener('click', function(e) {
                e.preventDefault();
                if (window.swiper) {
                    window.swiper.slideTo(3, 800);
                }
                hideDropdownOnMobile();
            });
        }
    }

    // Khởi tạo menu click handlers
    initMenuClick();
});

